import { useQuery } from "@tanstack/react-query"
import { useSelectedPlanContext } from "../contexts/SelectedPlanContext"

const useFetchResources = (serviceType, selectedLocationIataCode) => {
  const { changeSelectedPlan } = useSelectedPlanContext()

  const fetchResources = async () => {
    try {
      const response = await fetch(
        `${process.env.GATSBY_SERVICES_ENDPOINT}${serviceType}/resources?location=${selectedLocationIataCode}`
      )

      if (!response.ok) {
        throw new Error("Failed to fetch data")
      }

      const data = await response.json()
      // Process the data and set default inputs
      Object.keys(data).forEach(inputs => {
        data[inputs].forEach(input => {
          if (input.in_plan) {
            let defaultInput = {
              id: input.id,
              value: input.value,
            }

            // Check for case mismatches and set default inputs
            changeSelectedPlan(prevState => ({
              ...prevState,
              [inputs === "prefixes"
                ? "prefix"
                : inputs === "energies"
                ? "energy"
                : inputs === "nas"
                ? "nas"
                : inputs.slice(0, -1)]: defaultInput,
            }))
          }
        })
      })
      return data
    } catch (error) {
      console.error(`${`Error fetching ${serviceType} + "resources:`}`, error)
      throw error
    }
  }

  return useQuery({
    queryKey: ["resources", selectedLocationIataCode],
    queryFn: fetchResources,
    refetchOnWindowFocus: false,
    enabled: true,
  })
}

export default useFetchResources
